import awTitle from './aw-title'
import buyRite from './buy-rite'
import EDSJobMap from './eds-job-map'
import gtHousing from './gt-housing'

const projects = new Map([
    ['awT', awTitle],
    ['br', buyRite],
    ['ejm', EDSJobMap],
    ['gtH', gtHousing],
])

export default projects
